import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-72e5d33e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "media-container" }
const _hoisted_2 = { class: "media-head" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "head_content" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "left_tips" }, "LINKARD"),
  /*#__PURE__*/_createElementVNode("span", null, "社媒聚合页"),
  /*#__PURE__*/_createElementVNode("div", { class: "right_line" })
], -1))
const _hoisted_4 = {
  key: 0,
  class: "media-body"
}
const _hoisted_5 = ["onClick"]
const _hoisted_6 = { class: "item-name" }
const _hoisted_7 = {
  key: 1,
  class: "media-empty"
}
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "暂无内容", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_van_image = _resolveComponent("van-image")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createVNode(_component_van_image, {
        class: "back_action",
        src: require('../assets/image/white_btn_icon.svg'),
        onClick: _ctx.close
      }, null, 8, ["src", "onClick"])
    ]),
    (_ctx.requestDone && _ctx.linksListRes.length > 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.linksListRes, (item, index) => {
            return (_openBlock(), _createElementBlock("div", { key: index }, [
              _createElementVNode("div", {
                class: _normalizeClass(["media-item", { active: item.isTop }]),
                onClick: ($event: any) => (_ctx.handleLink(item))
              }, [
                (item.icon)
                  ? (_openBlock(), _createBlock(_component_van_image, {
                      key: 0,
                      width: "0.64rem",
                      height: "0.64rem",
                      src: item.icon
                    }, null, 8, ["src"]))
                  : _createCommentVNode("", true),
                _createElementVNode("span", _hoisted_6, _toDisplayString(item.name), 1)
              ], 10, _hoisted_5)
            ]))
          }), 128))
        ]))
      : _createCommentVNode("", true),
    (_ctx.requestDone && _ctx.linksListRes.length == 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
          _createVNode(_component_van_image, {
            src: require('../assets/image/icon-empty-dark.png')
          }, null, 8, ["src"]),
          _hoisted_8
        ]))
      : _createCommentVNode("", true)
  ]))
}